import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { ShowSection } from 'framework/ui/layout';

interface ClientUsersListSectionProps {
  title: string;
  content: ReactNode;
}

const ClientUsersListSection = ({ title, content }: ClientUsersListSectionProps) => {
  return (
    <ShowSection
      title={
        <Typography variant="h4" color="primary">
          {title}
        </Typography>
      }
      justifyContent="space-between"
      sx={{
        '&.section-details__wrapper': { p: '0px !important', width: '100%' },
        '& .section-details__actions': { mt: 0 },
        '.show-title-container': { mb: 0, py: 1, display: 'flex', px: 2 },
        '.show-title-container > div': { alignItems: 'center', display: 'flex', gap: 1 },
      }}
    >
      <Box sx={{ height: '1px', bgcolor: 'border.default', mb: 2 }} />
      <Box sx={{ px: 2 }}>{content}</Box>
    </ShowSection>
  );
};

export default ClientUsersListSection;
